import initializeCart from "./components/cart/cart";

$(() => {
    initializeCart();
});
